<template>
    <v-multiselect
        :options="{
                options: options,
                label: 'name',
                trackBy: 'key',
                multiple: false,
                searchable: false
                }"
        :id="id"
        v-model="currentLanguage"
    >
        <template #singleOption="{ option }">
            <img style="margin-right: 5px" height="20" :src="`/imgs/icons/${option.key}.png`" alt="flag"/>
        </template>
        <template #option="{ option }">
            <img style="margin-right: 5px" height="20" :src="`/imgs/icons/${option.key}.png`" alt="flag"/>
            <label>{{ option.name }}</label>
        </template>
    </v-multiselect>
</template>

<script>
export default {
    name: "LanguageSwitch",
    props: {
        id: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        storeToken: {
            type: String
        }
    },
    data() {
        return {
            currentLanguage: {
                'name': this.$i18n.locale === 'mne' ? 'Crnogorski' : 'English',
                'key': this.$i18n.locale,
                'url': ''
            }
        }
    },
    watch: {
        'currentLanguage': 'switchLanguage'
    },
    methods: {
        async switchLanguage() {
            if (this.storeToken) {
                await axios.put(`/api/store/${this.storeToken}/update/language`, {language: this.currentLanguage.key});
            }

            window.location.href = `${this.currentLanguage.url}${window.location.search}`;
        }
    }
}
</script>

<style scoped>
/deep/ .multiselect--above > .multiselect__tags,
/deep/ .multiselect__tags,
/deep/ .multiselect--above .multiselect__content-wrapper,
/deep/ .multiselect__content-wrapper {
    border: none !important;
    border-bottom: none !important;
    border-top: none !important;
}

/deep/ .multiselect--active {
    width: 200px;
}
</style>
